module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/babel-runtime/core-js/json/stringify.js
// module id = 1978
// module chunks = 2